var tag1 = "";
var tag2 = "Corrapol PVC Sheets";
var tag3 = "Corrapol Flashings and Fixings";
var rfnm = 1;
var collection1 = 0;
var collection2 = 0;
var lntha = 0;
var lnthb = 0;
var lnthc = 0;
var double = 1;
var quantity = 1;
var sheets = 1;
var clrcart = 0;
var products = [];
var products1 = [];
var products2 = [];
var colours1 = [];
var colours2 = [];
var colour1 = '';
var colour2 = '';
var mycart = [];
var newcart = [];
var mcaheaders = {method: 'get', headers: new Headers({'Authorization': 'Token 56e79298c2a7bf646d367522b3e2350ee6841de1','Content-Type': 'application/x-www-form-urlencoded'})};
var apiurl = 'https://myclearamber.com/mycapi/v1/cashop/';
if("cas.grokurv.co.uk" == window.location.hostname){
  var apiurl = 'https://myclearamber.com/mycapi/v1/cashopDev/';
}

$(".roofcal .roofimg").click(function(){
  	tag1 = $(this).attr('title');
  	rfnm = $(this).attr('key');
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
  	$('.roofsheet img').attr('src',$(this).find('img').attr('src'));
  	$('.roofsheet img').attr('key',$(this).find('img').attr('src'));
  	$('.roofsize img').attr('src',$(this).find('img').attr('src'));
  	$('.roofsize img').attr('key',$(this).find('img').attr('src'));
  	collection11();
  	collection22();
//   	$('.roofselect .crs, .roofselect .rscolor').trigger('onChange').attr('disabled','disabled');
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
});

$(".roofcal .yrc").click(function(){
  	if(tag1 == ''){
    	return false;
    }
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
})

$('.crs').change(function(){
  	tag2 = $(this).val();
  	collection11();
})

function collection11(){
  	console.log("Test new");
  	var colfltr = tag1+" || "+tag2;
  	var tags = fetch(apiurl+"products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
//         				console.log(data['results']);
//         				collection1 = data['collections'][0];
        				collection1 = data['results'][0];
        				products1 = data['results'];
//         				console.log(products1);
        				cproducts(data['results'], 1);
        				return data 
                    });
}

$('.rscolor').change(function(){
  	tag3 = $(this).val();
  	collection22();
})

function collection22(){
	var colfltr = tag1+" || "+tag3;
//   	var tags = fetch("/admin/api/2022-01/collections.json?title="+colfltr)
  	var tags = fetch(apiurl+"products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
//         				collection2 = data['collections'][0];
        				collection2 = data['results'][0];
        				products2 = data['results'];
        				cproducts(products2, 2);
//         				cproducts(collection2['id'], 2);
        				return data 
                    });
}

$('select[name="colour1"]').change(function(){
  	clearCart();
  	newcart = [];
  	colour1 = $(this).val();
  	colour2 = colour1;
  	$('.roofselect button').attr('disabled',false);
	$('.products .tag1 select[name="COLOUR"]').val(colour1);
  	$('.products .tag1 select[name="COLOUR"]').attr('disabled','disabled');
  	if(tag2 == 'Corrapol-BT Sheets'){ $('select[name="colour2"]').val(colour1).trigger('change'); colour2 = colour1; }
  	var img = tag1.replaceAll('– ','');
  	img = img.replaceAll(' ','_')+"_"+rfnm;
  	var crtimg = $(".roofsheet img").attr("key");
  	$(".roofsheet img, .roofsize img").attr("src",crtimg.replace(img,"Corrapol-PVC_"+img+"_"+colour1));
//   	console.log(colour1, colour2);
})

$('select[name="colour2"]').change(function(){
  	colour2 = $(this).val();
	$('.products .tag2 select[name="COLOUR"]').val(colour2);
  	$('.products .tag2 select[name="COLOUR"]').attr('disabled','disabled');
})

$('.rfsize').click(function(){
// 	console.log("Select Roof Size ", tag1, tag2, tag3);
    if(tag2 == ''){
      	alert("Please select Roof Sheet Type");
      	return false;
    }
  	if(tag3 == ''){
      	alert("Please select Colour of Glazing Bars");
    	return false;
    }
  	if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){
//     	$('.roofszc').show();
      	$('.roofszc').hide();
    }else{
    	$('.roofszc').hide();
    }
    if(colour1 == '' || colour2 == ''){
      alert("Please select Colours First?");
      return false;
    }
  	$('.rooftype').hide();
  	$('.roofsheet').hide();
  	$('.roofsize').show();
//   	$('.products').show();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor, .roofcal .number.yrc").addClass("complete");
  	$(".roofcal .number.cyrs").addClass("current");
})

$('.srtype').click(function(){
	$('.rooftype').show();
  	$('.roofsheet').hide();
  	$('.roofsize').hide();
  	$('.products').html('').hide();
//   	$('input, select').val('');
  	$('.colour1, .colour2').hide();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("current");
})


function cproducts(pdata, tg){
	products = products.concat(pdata);
    if(tg == 1){
      variants(products1, tg);
      for(let i = 0; i < products1[0]['options'].length; i++){
        if(products1[0]['options'][i]['name']=='COLOUR'){
          colours1 = products1[0]['options'][i]['values'];
          clroption(colours1, 1);
        }
      }
    }
    if(tg == 2){
      variants(products2, tg);
      for(let i = 0; i < products2[0]['options'].length; i++){
        if(products2[0]['options'][i]['name']=='COLOUR'){
          colours2 = products2[0]['options'][i]['values'];
          clroption(colours2, 2);
        }
      }
    }
}

function variants(products, tg=1){
  	var allprod = '';
  	for(let i = 0; i < products.length; i++){
      	var options = '';
      	var optcls = '';
      	var ttl = '';
      	var tgstr = JSON.stringify(products[i]['tags']);
      	for(let j = 0; j < products[i]['options'].length; j++){
          drp = '';
          optcls = optcls+' '+products[i]['options'][j]['name'];
          for(let k = 0; k < products[i]['options'][j]['values'].length; k++){
          	drp += '<option>'+products[i]['options'][j]['values'][k].replaceAll("m","")+'</option>';
          }
          options += '<div>'+products[i]['options'][j]['name']+' <select name="'+products[i]['options'][j]['name']+'">'+drp+'</select> </div>';
      	}
      	if(products[i]['tags'].indexOf('PRODUCT') > 0){ ttl = products[i]['tags'].substring(products[i]['tags'].indexOf('PRODUCT'), products[i]['tags'].indexOf('PRODUCT')+9) }
      	allprod +='<div class="w-100 tag'+tg+' '+ttl.replace(' ','')+' prod'+products[i]['id']+' option'+products[i]['options'].length+' '+optcls+' "><div class="w-20 image"> <img src="'+products[i]['images'][0]['src']+'" alt="'+products[i]['title']+'" title="'+ttl+'"></div><div class="w-20">'+products[i]['title']+'</div><div class="w-20">'+options+'</div><div class="w-20"><input type="number" class="quantity" value="1"></div><div class="w-20 total"></div></div>';
    }
  	$('.products').append(allprod);
}

function clroption(colours, tg){
  if(tg == 1){
    var nclr = '<option value="">-- Select Colour --</option>';
    for(let i=0; i< colours.length; i++){
//     	$('select[name="colour1"]').append('<option>'+colours[i]+'</option>');
      nclr += '<option>'+colours[i]+'</option>';
    }
    $('select[name="colour1"]').html(nclr);
    $('select[name="colour1"]').show();
  }
  if(tg == 2){
    for(let i=0; i< colours.length; i++){
    	$('select[name="colour2"]').append('<option>'+colours[i]+'</option>');
    }
    $('select[name="colour2"]').show();
    if(tag2 == 'Corrapol-BT Sheets'){
      $('select[name="colour2"]').hide();
    }
  }
}

$('.ckit').click(function(){
  	$(this).attr("disabled","disabled");
  	clearCart();
  	$('.products .total').html('');
  	lntha = parseInt($('.roofinput input[name="lengtha"]').val());
  	lnthb = parseInt($('.roofinput input[name="lengthb"]').val());
  	if(lntha < 99 || lnthb < 99){
    	alert("Please enter the valid length and width");
      	return false;
    }
  	for(let i = 0; i < products.length; i++){
    	if(products[i]['options'].length == 1){
          quantitycal(products[i], i);
        }
    }
  	lengthCal(products2);
  	updateCart();
})


function quantitycal(prdt, index){
//   console.log("Quantity ", prdt, lntha, lnthb);
  var lengthq = 1;
  var widthq = 1;
  if(lntha > 950){
//     lntha -= 100;
    lengthq = parseInt((lntha-100)/850)+1;
  }
  if(lnthb > 2000){
//     lnthb -= 150;
    widthq = parseInt((lnthb-150)/1850)+1;
  }
  quantity = lengthq*widthq;
  $('.products .option1 .quantity').val(quantity*double);		// Fill the Quantity
  $('.products .PACK .quantity').val(quantity*double*2);		// Fill the pack quantity
  return quantity*double;
}

function lengthacal(){
	var lengthq = 1;
  	if(lntha > 950){
//       lntha -= 100;
      lengthq = parseInt((lntha-100)/850)+1;
    }
  return lengthq;
}
function lengthbcal(newb,ltb){
	var widthq = 1;
  	if(newb > ltb){
//       lnthb -= 150;
      widthq = parseInt((newb-150)/(ltb-150))+1;
    }
  return widthq;
}

function updateCart(){
  
  for(let p=0; p<products2.length; p++){
    for(let v=0; v<products2[p]['variants'].length; v++){
//     	console.log(products2[p]['variants'][v]);
//       if(products2[p]['variants'][v]['title'] == colour2+' / 10 Pack'){
      if(products2[p]['variants'][v]['title'] == 'Clear / 10 Pack'){
      	// $('.products .PACK .total').html("SKU : <strong>"+products2[p]['variants'][v]['sku']+"</strong> Variant ID : "+products2[p]['variants'][v]['id']);
        newcart.push({"sno":"PRODUCT2", "quantity":sheets*2, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"PACK", "tag":2});
      }
    }
  }
  console.log("New Cart Items =", newcart);


  function sortProducts(data) {
    return data.sort((a, b) => {
      const numA = parseInt(a.sno.replace("PRODUCT", ""), 10);
      const numB = parseInt(b.sno.replace("PRODUCT", ""), 10);
      return numA - numB;
    });
  }
  const sortedData = sortProducts(newcart);
  // 	var cartContents = fetch('/cart.js')
  //   		.then(response => response.json())
  //   		.then(data => { mycart=data; return data });
  //  	console.log(mycart);
      // Add Product to Cart
    var citems = [];
    for(let c=0; c<sortedData.length; c++){
      if (JSON.stringify(citems).indexOf(sortedData[c]['variant']) > 0){
        for (let v = 0; v < citems.length; v++) {
          if (citems[v]['id']) { citems[v]['quantity'] = citems[v]['quantity']+sortedData[c]['quantity']; }
        }
      }else{
        citems.push({"quantity":sortedData[c]['quantity'], "id":sortedData[c]['variant'], properties: {"ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":sortedData[c]['sno'] }});
      }
      // citems.push({"quantity":newcart[c]['quantity'], "id":newcart[c]['variant'], properties: {"ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":newcart[c]['sno']}});
    }

    citems.reverse();

    myInterval = setInterval(function () {
      if(clrcart == 0){
        jQuery.post('/cart/add.js', {
          items: citems
        }).then(data => {
          $(".ckit").attr("disabled",false);
          // window.location.href = '/cart';
          if(window.location.pathname.indexOf('fr-fr') == 1){ window.location.href = '/fr-fr/cart'; }else{ window.location.href = '/cart'; }
        });
        clearInterval(myInterval);
      }else{
          console.log(clrcart);
      }
    }, 500);
}

function lengthCal(prod){
  var apex = 1;
  if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){
    apex = 2;
  }
  for(let p=0; p<products1.length; p++){
//     lengthCal(products1[p]);
//     console.log(quantity, double);
    	Prodlength1(products1[p], apex)
//     sheets = quantity*apex;
//     newcart.push({"sno":"PRODUCT1", "quantity":sheets, "product":products1[p]['id'], "title":products1[p]['variants'][0]['title'], "variant":products1[p]['variants'][0]['vid'], "sku":products1[p]['variants'][0]['sku'], "class":"COLOUR", "tag":1});
//     for(let v=0; v<products1[p]['variants'].length; v++){
//       if(products1[p]['variants'][v]['title'] == colour1){
//         $('.products .tag1 .total').html("SKU : <strong>"+products1[p]['variants'][v]['sku']+"</strong> Variant ID : "+products1[p]['variants'][v]['id']);
//         newcart.push({"sno":"PRODUCT1","product":products1[p]['id'], "title":products1[p]['variants'][v]['title'], "variant":products1[p]['variants'][v]['vid'], "sku":products1[p]['variants'][v]['sku'], "quantity":quantity*double, "class":"COLOUR", "tag":1});
//       }
//     }
  }
  
  for(let p = 0; p < products2.length; p++){
    var lthoption = [];
    var ttl = '';
    var tgstr = JSON.stringify(products2[p]['tags']);
    // if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+9).replace(' ','') }
    if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+10).replace(' ','').replace('"','') }
    for(let opt = 0; opt < products2[p]['options'].length; opt++){
      if(ttl == 'PRODUCT3' && tag1 == 'Apex – Free Standing'){
      	double = 4;
      }else if(ttl == 'PRODUCT3' && tag1 != 'Single Slope – Lean To Against Back and Side Wall'){
      	double = 2;
      }else{
      	double = 1;
      }
      if(products2[p]['options'][opt]['name']=='LENGTH'){
        let oroption = products2[p]['options'][opt]['values'];
        let noptions = oroption.toString().replaceAll('m','').split(',').sort();
        noptions = noptions.map(function(element) { if(element > 20){ return element; } return element*1000; })
        if(ttl == 'PRODUCT3' || ttl == 'PRODUCT7'){
        	lengthOnly(lnthb, noptions, lthoption, oroption, ttl);
        }else{
        	lengthOnly(lntha, noptions, lthoption, oroption, ttl);
        }
        
      }
      if(ttl == 'PRODUCT5'){
        var pqty = quantitycal(products2[p], i);
        pqty = sheets*4;
        newcart.push({"sno":"PRODUCT5", "quantity":pqty, "product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
      }
      if(ttl == 'PRODUCT6'){
        var qt6 = 1;
        if(tag1 == 'Single Slope – Lean To Against Back Wall'){
        	qt6 = parseInt((lntha)/10000);
        	if((lntha)%10000 != 0){ qt6 += 1; }
        }
        if(tag1 == 'Single Slope – Lean To Against Back and Side Wall'){
        	qt6 = parseInt((lntha+lnthb)/10000);
        	if((lntha+lnthb)%10000 != 0){ qt6 += 1; }
        }
        if(tag1 == 'Apex – Lean To'){
        	qt6 = parseInt((lnthb*2)/10000);
        	if((lnthb*2)%10000 != 0){ qt6 += 1; }
        }
        
        $('.products .PRODUCT6 input').val(qt6);
        newcart.push({"sno":"PRODUCT6", "quantity":qt6, "product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
      }
      if(ttl == 'PRODUCT9' && tag1 =='Apex – Free Standing'){
        $('.products .PRODUCT9 input').val(2);
        for(let v = 0; v < products2[p]['variants'].length; v++){
          if(products2[p]['variants'][v]['title'] == colour2){
          	newcart.push({"sno":"PRODUCT9", "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "quantity":2, "class":"WIDTH", "tag":2});
          }
        }
      }
      if(ttl == 'PRODUCT9' && tag1 =='Apex – Lean To'){
        $('.products .PRODUCT9 input').val(1);
        for(let v = 0; v < products2[p]['variants'].length; v++){
          if(products2[p]['variants'][v]['title'] == colour2){
          	newcart.push({"sno":"PRODUCT9", "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "quantity":1, "class":"WIDTH", "tag":2});
          }
        }
      }
      // if(ttl == 'PRODUCT10'){
      //   let noptions = products2[p]['options'][1]['values'].toString().replaceAll('mm','').replaceAll(' ','').split(',').sort();
      //   noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
      //   var sizeb = noptions[noptions.length-1];
      //   var newlth = lntha%sizeb;
      //   for(let v=0; v<products2[p]['variants'].length; v++){
      //     console.log(products2[p]['variants'][v], sizeb, newlth, colour1+' / '+(sizeb/1000).toFixed(1)+'m', ttl);
      //     if(products2[p]['variants'][v]['title'] == colour1+' / '+(sizeb/1000).toFixed(1)+'m'){
      //       var qty10 = parseInt(lntha/sizeb);
      //       newcart.push({"sno":ttl,"product":products2[p]['id'], "quantity":qty10, "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
      //     }
      //   }
      //   for (let b = 0; b < noptions.length; b++) {
      //     if(newlth <= noptions[b]){
      //       sizeb = noptions[b];
      //       break;
      //     }
      //   }
      //   for(let v=0; v<products2[p]['variants'].length; v++){
      //     if(newlth != 0 && products2[p]['variants'][v]['title'] == colour1+' / '+(sizeb/1000).toFixed(1)+'m'){
      //       newcart.push({"sno":ttl,"product":products2[p]['id'], "quantity":1, "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"COLOUR", "tag":1});
      //     }
      //   }
      //   // console.log(newcart);
      // }
    }
    $('.products .'+products2[p]["id"]+' .total').html("");
    for(let v = 0; v < products2[p]['variants'].length; v++){
//     	console.log(products2[p]['variants'][v], lthoption);
      for(let l = 0; l < lthoption.length; l++){
        if(lthoption.length > 0 && products2[p]['variants'][v]['title'] == colour2+' / '+lthoption[l]['length']){
          	$('.products .prod'+products2[p]["id"]+' .total').append("<p>SKU : <strong>"+products2[p]['variants'][v]['sku']+"</strong> Variant : "+products2[p]['variants'][v]['title']+' qty : '+lthoption[l]['quantity']+'</p>');
//         	$('.products .6755399761973 .total').append("<p>SKU : <strong>"+products2[p]['variants'][v]['sku']+"</strong> Variant ID : "+products2[p]['variants'][v]['id']+'</p>');
        	newcart.push({"sno":ttl, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "quantity":lthoption[l]['quantity'], "class":"LENGTH "+ttl, "tag":2});
        }
      }
    }
  }
//   console.log(newcart);
}

function lengthOnly(input, nopt, lthoption, oroption, ttl){
//   	console.log(input, nopt, lthoption, oroption, ttl, tag1, nopt[nopt.length-1]);
  	var mult = 1;
//   	console.log(double);
//   	if((ttl == 'PRODUCT3') && (tag1 == 'Single Slope – Free Standing' || tag1 == 'Single Slope – Lean To Against Back Wall')){ mult = 2; }
  	if(ttl == 'PRODUCT8' || (ttl == 'PRODUCT7' && tag1 == 'Single Slope – Lean To Against Back and Side Wall') ){ double=1; }
  	if(ttl == 'PRODUCT7' && tag1 == 'Apex – Lean To'){ double=2; }
	if(input > nopt[nopt.length-1]){	// nopt.at(-1)
      console.log("Max Length product ", input, double);
      var max = parseInt(input/nopt.at(-1));
      var rem = input%nopt.at(-1);
      lthoption.push({"length":oroption.at(-1),"quantity":max*mult*double});
//       console.log(max, rem);
      for(let k = 0; k < nopt.length; k++){
        let looplnth = parseFloat(nopt[k]);
        if(rem <= looplnth){
          lthoption.push({"length":oroption[k],"quantity":1*mult*double});
          break;
        }
      }
    }else{
      for(let k = 0; k < nopt.length; k++){
        let looplnth = parseFloat(nopt[k]);
        if(input <= looplnth){
          lthoption.push({"length":oroption[k],"quantity":1*mult*double});
          break;
        }
      }
    }
}

function Prodlength1(prod, apex){
  	let qty1 = 0;
  	let qty2 = 0;
  	let waste = 0;
  	let nlthb = lnthb;
  	let noptions = prod['options'][0]['values'].toString().replaceAll('m','').split(',').sort();
  	noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort();
  	var mult = 1;
  	var lstvidx = noptions.length-1;
  	qty1 = lengthacal();
  	if(lnthb > parseInt(noptions[lstvidx])){	// nopt.at(-1)
    	var max = parseInt(nlthb/noptions.at(-1));
      	var rem = (lnthb%noptions.at(-1))+(max*150);
        sheets = qty1*max*apex;
        newcart.push({"sno":"PRODUCT1", "quantity":sheets, "product":prod['id'], "title":prod['variants'][lstvidx]['title'], "variant":prod['variants'][lstvidx]['vid'], "sku":prod['variants'][lstvidx]['sku'], "class":"COLOUR", "tag":1});
        for(let j = 0; j < noptions.length; j++){
          console.log("123123 ", noptions.length, rem+150, lnthb, noptions[j]);
          if(rem <= noptions[j]){
            sheets += qty1*apex;
            newcart.push({"sno":"PRODUCT1", "quantity":qty1*apex, "product":prod['id'], "title":prod['variants'][j]['title'], "variant":prod['variants'][j]['vid'], "sku":prod['variants'][j]['sku'], "class":"COLOUR", "tag":1});
            // console.log("Internal loop ", noptions[k]);
            break;
          }
        }
      	// for(let k = 0; k < noptions.length; k++){
       //  	let looplnth = parseFloat(noptions[k]);
       //    	console.log(looplnth, rem);
       //    	if(rem+(150*max) <= looplnth){
       //        	// Need to check waste management
       //        	waste = (max*noptions[lstvidx]+noptions[k])-lnthb-(150*max);
       //        	console.log(waste,rem+noptions.at(-1), "Max", max);
       //        	if(waste > 500){
       //            	// max -= 1;
       //            	sheets = qty1*max*apex;
       //            	newcart.push({"sno":"PRODUCT1", "quantity":sheets, "product":prod['id'], "title":prod['variants'][lstvidx]['title'], "variant":prod['variants'][lstvidx]['vid'], "sku":prod['variants'][lstvidx]['sku'], "class":"COLOUR", "tag":1});
       //            	newb = rem+noptions.at(-1);
       //          	wastage(noptions.slice(0,-1),newb+150, apex);
       //          }else{
       //          	sheets = qty1*max*apex;
       //            	newcart.push({"sno":"PRODUCT1", "quantity":sheets, "product":prod['id'], "title":prod['variants'][lstvidx]['title'], "variant":prod['variants'][lstvidx]['vid'], "sku":prod['variants'][lstvidx]['sku'], "class":"COLOUR", "tag":1});
       //            	for(let j = 0; j < noptions.length; j++){
       //                console.log("123123 ", noptions.length, rem+150, lnthb, noptions[j]);
       //                if(rem+150 <= noptions[j]){
       //                  sheets += qty1*apex;
       //                  newcart.push({"sno":"PRODUCT1", "quantity":qty1*apex, "product":prod['id'], "title":prod['variants'][j]['title'], "variant":prod['variants'][j]['vid'], "sku":prod['variants'][j]['sku'], "class":"COLOUR", "tag":1});
       //                  console.log("Internal loop ", noptions[k]);
       //                  break;
       //                }
       //              }
       //          }
       //      	break;
       //      }
       //  }
      	
    }else{
    	for(let k = 0; k < noptions.length; k++){
          let looplnth = parseFloat(noptions[k]);
          if(lnthb <= looplnth){
            qty2 = lengthbcal(lnthb,parseInt(noptions.at(-1)));
            sheets = qty1*qty2*apex;
            newcart.push({"sno":"PRODUCT1", "quantity":sheets, "product":prod['id'], "title":prod['variants'][k]['title'], "variant":prod['variants'][k]['vid'], "sku":prod['variants'][k]['sku'], "class":"COLOUR", "tag":1});
            break;
          }
        }
    }
}

function wastage(arry, newb, apex){
	console.log("New checking ", arry, newb);
  	qty1 = lengthacal();
  	sheets += qty1*2*apex;
  	if(arry[0]*2 - newb < 500 && arry[0]*2 - newb > 0){
    	console.log("Variant. =",arry[0], arry[0]*2 - newb);
//       	sheets += qty1*2*apex;
      	newcart.push({"sno":"PRODUCT1", "quantity":qty1*2*apex, "product":products1[0]['id'], "title":products1[0]['variants'][0]['title'], "variant":products1[0]['variants'][0]['vid'], "sku":products1[0]['variants'][0]['sku'], "class":"COLOUR", "tag":1});
    }
  	else if(arry[1]*2 - newb < 500 && arry[1]*2 - newb > 0){
    	console.log("Variant. =",arry[1], arry[1]*2 - newb);
//       	sheets += qty1*2*apex;
      	newcart.push({"sno":"PRODUCT1", "quantity":qty1*2*apex, "product":products1[0]['id'], "title":products1[0]['variants'][1]['title'], "variant":products1[0]['variants'][1]['vid'], "sku":products1[0]['variants'][1]['sku'], "class":"COLOUR", "tag":1});
    }
  	else if(arry[0]+arry[1] - newb < 500 && arry[0]+arry[1] - newb > 0){
    	console.log("Variant. =",arry[0],arry[1], arry[0]+arry[1] - newb);
//       	sheets += qty1*2*apex;
      	newcart.push({"sno":"PRODUCT1", "quantity":qty1*apex, "product":products1[0]['id'], "title":products1[0]['variants'][0]['title'], "variant":products1[0]['variants'][0]['vid'], "sku":products1[0]['variants'][0]['sku'], "class":"COLOUR", "tag":1});
      	newcart.push({"sno":"PRODUCT1", "quantity":qty1*apex, "product":products1[0]['id'], "title":products1[0]['variants'][1]['title'], "variant":products1[0]['variants'][1]['vid'], "sku":products1[0]['variants'][1]['sku'], "class":"COLOUR", "tag":1});
    }else{
      	console.log("Else Case");
    	newcart.push({"sno":"PRODUCT1", "quantity":qty1*2*apex, "product":products1[0]['id'], "title":products1[0]['variants'][0]['title'], "variant":products1[0]['variants'][0]['vid'], "sku":products1[0]['variants'][0]['sku'], "class":"COLOUR", "tag":1});
    }
}

function clearCart(){
  	clrcart = 1;
  	newcart = [];
	$.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
//             Shopify.clear();
          clrcart = 0;
        },
        error: function(XMLHttpRequest, textStatus) {
          clrcart = 0;
          console.log("Clear Cart Error");
          /* error code */
        }
      });
}